<template>
  <div v-if="start">
    <div class="w-full">
      <vx-card>
        <vs-table
          class="mb-6"
          no-data-text="Клиентов нет"
          stripe
          :data="clients">
          <template slot="thead">
            <vs-th sort-key="name">
              Имя
            </vs-th>

            <vs-th sort-key="phone">
              Телефон
            </vs-th>

            <vs-th class="justify-center" sort-key="transport_type">
              <div class="text-center w-full">
                Мессенджер
              </div>
            </vs-th>

            <vs-th sort-key="session_count">
              <div class="text-center w-full">
                Количество сессий
              </div>
            </vs-th>

            <vs-th sort-key="last_session_at">
              Последняя сессия
            </vs-th>

            <vs-th sort-key="created_at">
              Добавлен
            </vs-th>

            <vs-th>
              Экспорт
            </vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
              <vs-td :data="data[indextr].name">
                <router-link :to="{name: 'chats', params: {client_id: data[indextr].id}}" class="flex items-center items-center">
                  <vs-avatar
                    :src="data[indextr].profile_image_url"
                    :text="data[indextr].name"
                    class="mr-4" />
                  {{ data[indextr].name || data[indextr].nickname || 'Неизвестно' }}
                </router-link>
              </vs-td>

              <vs-td :data="data[indextr].phone">
                {{ data[indextr].phone }}
              </vs-td>

              <vs-td :data="data[indextr].transport_type">
                <div class="flex justify-center w-50">
                  <chat-logo
                    :chat-name="data[indextr].transport_type"
                    :size="'xs'"
                  />
                </div>
              </vs-td>

              <vs-td :data="data[indextr].sessions_count">
                <div class="text-center w-full">
                  {{ data[indextr].sessions_count }}
                </div>
              </vs-td>

              <vs-td :data="data[indextr].last_session_at">
                {{ data[indextr].last_session_at | momentFormat('DD.MM.YYYY HH:mm') }}
              </vs-td>

              <vs-td :data="data[indextr].created_at">
                {{ data[indextr].created_at | momentFormat }}
              </vs-td>

              <vs-td>
                <div class="flex justify-center">
                  <vx-tooltip text="Скачать историю переписки">
                    <vs-button
                      @click.prevent="handleClickDownload(data[indextr])"
                      class="icon-button"
                      type="flat"
                      size="large"
                      icon-pack="feather"
                      icon="icon-download" />
                  </vx-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <div
          :class="{'hidden': totalPages <= 1}"
        >
          <vs-pagination
            :total="totalPages"
            :max="maxPages"
            :value="page"
            @input="changePage"
          />
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import Client from '../../api/http/models/Client'
import moment from 'moment'
import downloadFile from '../../mixins/downloadFile'
import { mapGetters } from 'vuex'

import ChatLogo from '../messenger/components/ChatLogo'

export default {
  components: {
    ChatLogo
  },

  data () {
    return {
      start: false,
      totalPages: 0,
      page: parseInt(this.$route.query.page) || 1,
      clients: [],
      search: '',
      tags: ''
    }
  },

  computed: {
    ...mapGetters(['authUserCompany']),
    maxPages () {
      return Math.min(this.totalPages - 1, 9)
    }
  },

  mixins: [downloadFile],

  async created () {
    // await this.fetchClients(this.page)
    this.start = true
  },

  watch: {
    '$route.query': {
      deep: true,
      handler (newValue, oldValue) {
        if (
          newValue.search !== oldValue.search
          || newValue.tags !== oldValue.tags
        ) {
          this.changePage(1)
        }
      }
    }
  },

  methods: {
    async handleClickDownload (client) {
      const response = await Client.exportHistory(this.authUserCompany.slug, client.id)

      if (response) {
        const timezone = this.authUserCompany.timezone || 0
        const timestamp = moment.utc(new Date()).utcOffset(timezone).valueOf()
        const filename = `export_client_${client.id}_${timestamp}.html`
        this.downloadFile(response, filename)
      }
    },

    async fetchClients () {
      const response = await Client.getAll(this.authUserCompany.slug, this.page, this.search, this.tags)
      if (response.meta) {
        this.totalPages = response.meta.last_page
      }
      if (response.data) {
        this.clients = response.data
      }
    },

    async changePage (page) {
      if (this.page !== page) {
        this.$router.push({
          name: this.$route.name,
          query: {
            ...this.$route.query,
            page
          }
        })
      }
      this.page = page
      this.search = this.$route.query.search || ''
      this.tags = this.$route.query.tags || ''
      await this.fetchClients()
    }
  }
}
</script>
